import Close from '@mui/icons-material/Close';
import Search from '@mui/icons-material/Search';
import { IconButton, TextField, TextFieldProps } from '@mui/material';

const WIDTH = '300px';

export const SearchInput = ({
  ...props
}: TextFieldProps & { onReset?: () => void }) => {
  return (
    <TextField
      {...props}
      variant="outlined"
      sx={{
        input: {
          '&::placeholder': {
            justifySelf: 'flex-start',
            fontSize: 14,
            color: 'text.primary',
            opacity: 1,
          },
        },
        '& .Mui-focused fieldset': {
          borderColor: 'primary.main',
          borderWidth: '1px !important',
        },
        '& .MuiInputBase-root': {
          minHeight: '44px',
          borderRadius: '100px',
          '&:hover': {
            background: props.disabled
              ? 'action.disabledBackground'
              : 'action.hoverOpacity',
          },
          '& input[type="text"]': {
            width: props.value ? WIDTH : '50px',
            transition: '0.4s',
          },
          '& input[type="text"]:focus': {
            width: WIDTH,
          },
        },
        '& .MuiOutlinedInput-root': {
          '&:hover fieldset': {
            borderColor: props.disabled ? 'action.disabled' : 'primary.main',
          },
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: props.disabled
            ? 'action.disabled'
            : 'action.disabledBackground',
        },
      }}
      InputProps={{
        startAdornment: (
          <Search fontSize="small" sx={{ mr: '7px', color: 'text.primary' }} />
        ),
        endAdornment: (
          <IconButton
            aria-label="clear search"
            onClick={props.onReset}
            edge="end"
            sx={{
              visibility: props.value && props.onReset ? 'visible' : 'hidden',
            }}
          >
            <Close htmlColor="text.primary" fontSize="small" />
          </IconButton>
        ),
        ...props.InputProps,
      }}
      type="text"
    />
  );
};
